module.exports = __webpack_public_path__ + "static/media/MasjidBaitusSalam_Logo.e518f7ff.png";